import { Button } from '@bpinternal/ui-kit-next'
import { EmptyState } from '~/elements'

type Props = {
  navigateToHome: () => void
  title: string
  description: string
  showStatusPageLink?: boolean
}

export const ErrorState = ({ navigateToHome, title, description, showStatusPageLink = false }: Props) => (
  <div className="flex h-screen items-center">
    <div className="mx-auto w-1/2">
      <img className="mx-auto mb-6 h-40" src="/emptystate/Error.svg" />
      <EmptyState
        title={title}
        description={description}
        primaryAction={
          <Button size="sm" onClick={() => navigateToHome()}>
            Home
          </Button>
        }
        secondaryAction={
          showStatusPageLink && (
            <Button variant="link" size="sm" onClick={() => window.open('https://status.botpress.com/', '_blank')}>
              Status Page
            </Button>
          )
        }
      />
    </div>
  </div>
)
